/**
 * Resolve the logo for a card brand.
 *
 * Card brands used to be rendered by interpolating the stored value straight
 * into an asset filename. `require()` throws when the file is missing, and a
 * throw inside a render takes down the whole component, not just the image --
 * which is how a single card brought down PaymentRetrieve with
 * "Cannot find module './appAsset-brand--master.svg'".
 *
 * Two things reach us that no asset covers, and neither is a defect:
 *
 * - Webpay never reports a card type, so a large share of the stored cards
 *   carry an empty brand.
 * - Any brand a processor starts sending before we ship its logo.
 *
 * Requiring every asset up front is what makes this safe: webpack resolves the
 * paths at build time, so a missing file breaks the build instead of
 * production, and an unknown brand can only ever return null.
 *
 * Keys are the vocabulary of payments.models.CARD_BRANDS in the API.
 */
const CARD_BRAND_ASSETS = {
  AmericanExpress: require('@/assets/appAsset-brand--AmericanExpress.svg'),
  Diners: require('@/assets/appAsset-brand--Diners.svg'),
  Discover: require('@/assets/appAsset-brand--Discover.svg'),
  MasterCard: require('@/assets/appAsset-brand--MasterCard.svg'),
  Prepago: require('@/assets/appAsset-brand--Prepago.svg'),
  RedCompra: require('@/assets/appAsset-brand--RedCompra.svg'),
  Visa: require('@/assets/appAsset-brand--Visa.svg')
}

/**
 * Return the asset for a card brand, or null when there is none to show.
 * @param {string} brand value stored in Card.brand
 * @returns {string|null} resolved asset url, or null to fall back
 */
export function cardBrandAsset (brand) {
  return CARD_BRAND_ASSETS[brand] || null
}

export { CARD_BRAND_ASSETS }
